
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path);
}


/**
 * 6~16位，不包含空格
 * @returns 
 */
export function loginPassworValidate(str) {
    return /^[^\s]{6,16}$/.test(str);
}


export function _isEmpty(input) {
    return String(input) === 'null' || String(input) === 'undefined' || input === '';
}

/**
 * 密码验证
 * 密码规则：6-16位字符，同时包括数字、大写字母组合；
 * @param {*} str 
 * @returns 
 */
export function passwordValidate(str) {
    const reg = /^(?=.*[A-Z])(?=.*[0-9]).{6,16}$/;
    return reg.test(str);
}

/**
 * 输入文本格式限制
 * 以数字字母下划线开头，可以包含下划线，点和空格，逗号，加号和中划线存在
 * @param {*} str
 * @returns
 */
export function inputTextValidateSpecial(str) {
    const reg = /^[a-zA-Z_][a-zA-Z0-9_.,+ -]*$/;
    return reg.test(str);
}